import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';

import { Toast } from '@/shared/ui/toast/toast';
import { ToastItem, ToastPosition } from '@/core/toast/toast.types';

const POSITION_CLASSES: Record<ToastPosition, string> = {
  'top-right': 'top-4 right-4 items-end',
  'top-left': 'top-4 left-4 items-start',
  'bottom-right': 'bottom-4 right-4 items-end',
  'bottom-left': 'bottom-4 left-4 items-start',
  'top-center': 'top-4 left-1/2 -translate-x-1/2 items-center',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2 items-center',
};

@Component({
  selector: 'dialab-toast-container',
  imports: [Toast],
  templateUrl: './toast-container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': 'hostClass()' },
})
export class ToastContainer {
  readonly toasts = input.required<Signal<ToastItem[]>>();
  readonly onDismiss = input.required<(id: number) => void>();
  readonly position = input.required<Signal<ToastPosition>>();

  protected readonly items = computed(() => this.toasts()());
  protected readonly hostClass = computed(
    () =>
      `fixed z-50 flex flex-col gap-2 pointer-events-none ${POSITION_CLASSES[this.position()()]}`,
  );
}
